import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let lastPath = null;

export const track = (type, meta = {}) => {
  try {
    axios.post(`${API}/analytics/event`, {
      type,
      path: window.location.pathname,
      meta,
      ref: document.referrer || "",
    });
  } catch {
    /* analytics must never break the experience */
  }
};

export const trackPageView = (path) => {
  if (path === lastPath) return;
  lastPath = path;
  track("page_view");
};
